// extracted by mini-css-extract-plugin
module.exports = {"content":"WidgetNetSalesByProvider_content__24t-u"};